// ABOUTME: Utility functions for avatar URL construction with environment-aware absolute URL generation.
// ABOUTME: Handles development vs production URL conversion and maintains consistency across all avatar displays.

/**
 * Converts relative avatar URLs to absolute URLs based on current environment
 * @param relativeUrl - The relative URL path from the API or undefined/null
 * @returns Absolute URL string or undefined if input is invalid
 */
export const getAvatarUrl = (relativeUrl?: string | null): string | undefined => {
  // Return undefined for falsy inputs
  if (!relativeUrl) {
    return undefined;
  }

  // Return absolute URLs unchanged
  if (relativeUrl.startsWith('http')) {
    return relativeUrl;
  }

  // Ensure URL starts with slash for consistency
  const normalizedUrl = relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`;

  // Development environment: port 3000 uses API at port 5001
  if (window.location.port === '3000') {
    return `${window.location.protocol}//${window.location.hostname}:5001${normalizedUrl}`;
  }

  // Production environment: use current origin
  return `${window.location.origin}${normalizedUrl}`;
};